import React from "react";
import { MessageCircle } from "lucide-react";

const PHONE = "351000000000"; // placeholder editable

export const WhatsAppButton = () => {
    return (
        <a
            href={`https://wa.me/${PHONE}?text=${encodeURIComponent(
                "Olá! Tenho interesse no Sabor Líquido.",
            )}`}
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-floating"
            className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 rounded-full bg-brand-green hover:bg-brand-green-dark text-white px-5 py-4 shadow-pop transition-all hover:scale-105"
            aria-label="Falar pelo WhatsApp"
        >
            <MessageCircle className="h-5 w-5" />
            <span className="hidden sm:inline font-semibold text-sm">WhatsApp</span>
        </a>
    );
};
